<div class="account-editor-container">
  <fieldset>
    <legend>Change Password</legend>

    @if (isNativeUser) {
      <form [formGroup]="form">
        <div>
          <div class="mb-3 row g-3 align-items-center">
            <span class="password-label col-auto">Old Password:</span>
            <input type="password col-auto" [formControl]="oldPassword" class="form-control password-input" />
          </div>
          <div class="mb-3 row align-items-center">
            <span class="password-label col-auto">New Password:</span>
            <input type="password col-auto" [formControl]="newPassword" class="form-control password-input" />
          </div>
          <div class="mb-3 row align-items-center">
            <span class="password-label col-auto">Confirm New Password:</span>
            <input type="password col-auto" [formControl]="confirmNewPassword" class="form-control password-input" />
          </div>
          <div class="mb-3 row form-buttons">
            <span class="col-lg-4">
              <button type="button" pButton (click)="resetForm()" label="Reset Form"></button>
              <button type="button" pButton [disabled]="!setPasswordEnabled" (click)="setPassword()" label="Set Password"></button>
            </span>
          </div>
        </div>
      </form>
    }

    @if (isActiveDirectoryUser) {
      <p style="text-align: center; font-size: 24px; margin-top: 10px;">
        Change your password through Active Directory
      </p>
    }

    @if (isGoogleWorkspaceUser) {
      <p style="text-align: center; font-size: 24px; margin-top: 10px;">
        Change your password through Google Workspace
      </p>
    }

    @if (isSamlUser) {
      <p style="text-align: center; font-size: 24px; margin-top: 10px;">
        Change your password through your SAML Single Sign-On provider
      </p>
    }


  </fieldset>

  <theme-editor></theme-editor>

</div>
